import React, { useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import { FileUpload } from '../../../common/formElements/FileUpload';
import showAlert from '../../../common/utils/alert';
import ParentCardNoCol from '../../common/ParentCardNoCol';
import CustomCSSCDNForm from './CustomCSSCDNForm';
import ListCustomCSSCDNs from './ListCustomCSSCDNs';
import CssCodeEditor from '../CssCodeEditor';
import { toast } from 'react-toastify';
import ToggleButton from '../../../common/ui/ToggleButton';

export const CustomCssCDN = ({
  projectId,
  version,
  actions,
  projectDetail,
  showCustomCSSUrlLoader,
  appSetting,
  deleteFlag,
}) => {
  const [toggle, setToggle] = useState(false);
  const [isCssCdnCreate, setIsCssCdnCreate] = useState(true);
  const [customCssCdnUuid, setCustomCssCdnUuid] = useState('');
  const [isNewCustomCssCdn, setIsNewCustomCssCdn] = useState(false);
  const [isUpdateCustomCssCdn, setIsUpdateCustomCssCdn] = useState(false);
  const [copied, setCopied] = useState('');

  const { customCssCdns, toggleUnloadDefaultCSS, loadAllCssCdnToBuilder } = projectDetail;
  const loadDefaultCSS = !toggleUnloadDefaultCSS;
  const loadAllCssToBuilderCanvas = loadAllCssCdnToBuilder;

  const handleCustomCssCdnSubmit = (values) => {
    if (values && values.uuid) {
      actions.updateProjectCustomCssCdn({
        projectId,
        version,
        uuid: values.uuid,
        data: values,
      });
    } else {
      actions.addProjectCustomCssUrl({
        projectId,
        version,
        data: values,
      });
    }
  };

  const handleUnloadDefaultCss = () => {
    const text = loadDefaultCSS
      ? 'You are removing the default CSS. It may have unknown effect on the project.'
      : 'Loading default CSS on the project.';
    const preConfirm = () => {
      actions.toggleProjectDefaultCss({ projectId, version, data: {} });
    };
    showAlert(
      text,
      preConfirm,
      loadDefaultCSS ? 'Yes, unload it!' : 'Yes, load it!',
      loadDefaultCSS ? 'warning' : 'info',
    );
  };

  const handleUnloadAllCSSFromBuilder = () => {
    const text = loadAllCssToBuilderCanvas
      ? 'You are unloading all the URL/Tags from Builder Canvas.'
      : 'Enable loading of URL/Tags to Builder Canvas.';
    const preConfirm = () => {
      actions.toggleProjectCssCdnsFromBuilder({ projectId, version, data: {} });
    };
    showAlert(
      text,
      preConfirm,
      loadAllCssToBuilderCanvas ? 'Yes, unload it!' : 'Yes, load it!',
      loadAllCssToBuilderCanvas ? 'warning' : 'info',
    );
  };

  const handleCustomCssCdnDelete = (uuid) => {
    const preConfirm = () => {
      actions.deleteProjectCustomCssUrl({ projectId, version, uuid });
    };
    showAlert("You won't be able to revert this.", preConfirm, 'Yes, delete it!');
  };

  const copyToClipboard = (urlOrTag) => {
    setCopied(urlOrTag);
    toast.success('Copied to clipboard');
    setTimeout(() => {
      setCopied('');
    }, 2000);
  };

  return (
    <>
      <Modal isOpen={toggle} toggle={() => setToggle(false)} backdrop="static">
        <ModalHeader toggle={() => setToggle(false)} className="border-bottom">
          <strong>Upload Custom CSS</strong>
        </ModalHeader>
        <ModalBody className="d-flex flex-column justify-content-center align-items-center">
          <FileUpload
            url={`${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/custom-css-cdn/file`}
            projectId={projectId}
            version={version}
            maxFiles={1}
            maxSizeBytes="20971520"
            accept="text/css"
            fileIcon="customTheme"
            submitAction={() => actions.loadCustomCssCdns({ projectId, version })}
          />
        </ModalBody>
      </Modal>
      <ParentCardNoCol
        title="Add CSS URL/Link Tag"
        bgColor="drapcode-violet"
        icon="customCSSURL"
        CtaComponent={
          <>
            <ToggleButton
              name="loadAllCssCdnToBuilder"
              title="Load All to Builder Canvas"
              text="Load All to Builder Canvas"
              onChange={handleUnloadAllCSSFromBuilder}
              isChecked={loadAllCssToBuilderCanvas}
            />
            <ToggleButton
              name="unloadDefaultCss"
              title="Load Default CSS (Default: True)"
              text="Load Default CSS"
              onChange={handleUnloadDefaultCss}
              isChecked={loadDefaultCSS}
            />
            <button className="btn btn-theme-submit btn-md" onClick={() => setToggle(true)}>
              <i className="wb webconnect-cloud-arrow-up-fill"></i>&nbsp;Upload CSS&nbsp;
            </button>
            &nbsp;
            <button
              type="button"
              className="btn btn-theme-submit btn-md"
              onClick={() => {
                setIsNewCustomCssCdn(true);
                setIsCssCdnCreate(true);
                setCustomCssCdnUuid('');
              }}
            >
              <i className={`wb ${drapcodeIcon('add')}`}></i> Add CSS URL/Link Tag&nbsp;
            </button>
          </>
        }
      >
        {(isNewCustomCssCdn || isUpdateCustomCssCdn) && (
          <CustomCSSCDNForm
            customCssCdns={customCssCdns}
            handleCustomCssCdnSubmit={handleCustomCssCdnSubmit}
            showCustomCSSUrlLoader={showCustomCSSUrlLoader}
            closeNewCustomCSSCdn={() => {
              setIsNewCustomCssCdn(false);
              setIsUpdateCustomCssCdn(false);
              setIsCssCdnCreate(true);
            }}
            isCssCdnCreate={isCssCdnCreate}
            customCssCdnUuid={customCssCdnUuid}
          />
        )}
        {customCssCdns && customCssCdns.length > 0 && (
          <ListCustomCSSCDNs
            projectId={projectId}
            version={version}
            projectDetail={projectDetail}
            customCssCdns={customCssCdns}
            handleCustomCssCdnDelete={handleCustomCssCdnDelete}
            actions={actions}
            deleteFlag={deleteFlag}
            copyToClipboard={copyToClipboard}
            openCustomCSSCDNForm={(uuid) => {
              setIsUpdateCustomCssCdn(true);
              setIsCssCdnCreate(false);
              setCustomCssCdnUuid(uuid);
            }}
          />
        )}
      </ParentCardNoCol>
      {appSetting.cssUuid && !appSetting.fetchCssdataPending && (
        <Modal
          isOpen={appSetting.isOpenCssEditorModal}
          toggle={() => actions.toggleCssEditorModal()}
          backdrop="static"
          style={{ maxWidth: '70%', marginTop: '70px' }}
        >
          <ModalHeader toggle={() => actions.toggleCssEditorModal()} className="border-bottom">
            <strong>View/Edit CSS</strong>
          </ModalHeader>
          <ModalBody>
            <CssCodeEditor projectId={projectId} appSetting={appSetting} version={version} />
          </ModalBody>
        </Modal>
      )}
    </>
  );
};
